import React from "react";
import FlexBox from "view/components/Layout/FlexBox";
import FFairLogo from "view/images/FFairLogo";
import CancelIcon from "@material-ui/icons/Cancel";
import {green, red} from "@material-ui/core/colors";
import {Button} from "@mui/material";
import {Link} from "react-router-dom";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {LOGIN_PATH} from "view/routes";
import useStyles from "./styles";

type NoAccessWrapperProps = {
  children: React.ReactNode;
};

function NoAccessWrapper({children}: NoAccessWrapperProps) {
  const classes = useStyles();
  return (
    <FlexBox width="100vw" height="100vh" column alignCenter justifyCenter>
      <FlexBox className={classes.noAccessWrapper} column gap={2} alignCenter>
        <FFairLogo width={64} height={64} />
        <span className={classes.ffairLogoText}>FFAIR</span>
        {children}
        <Link to="/">
          <Button color="primary" variant="contained" fullWidth={false}>
            Close
          </Button>
        </Link>
      </FlexBox>
    </FlexBox>
  );
}

function SuccessWrapper({children}: NoAccessWrapperProps) {
  const classes = useStyles();
  return (
    <FlexBox width="100vw" height="100vh" column alignCenter justifyCenter>
      <FlexBox className={classes.noAccessWrapper} column gap={2} alignCenter>
        <FFairLogo width={64} height={64} />
        <span className={classes.ffairLogoText}>FFAIR</span>
        {children}
        <Link to={LOGIN_PATH}>
          <Button color="primary" variant="contained" fullWidth={false}>
            LOGIN
          </Button>
        </Link>
      </FlexBox>
    </FlexBox>
  );
}

export function InvalidExhibitorEmailChange() {
  const classes = useStyles();
  return (
    <NoAccessWrapper>
      <FlexBox gap={1} alignCenter>
        <CancelIcon htmlColor={red[500]} />
        <span className={classes.noLongerValidMessage}>
          Email change request is no longer valid.
        </span>
      </FlexBox>
      <span className={classes.commonText}>
        This request has expired or has already been processed.
        <br />
        <br />
        Please contact the organiser for help.
      </span>
    </NoAccessWrapper>
  );
}

export function SuccessfulExhibitorEmailChange() {
  const classes = useStyles();

  return (
    <SuccessWrapper>
      <FlexBox gap={1} alignCenter>
        <CheckCircleIcon htmlColor={green[500]} />
        <span className={classes.validMessage}>Email updated successfully</span>
      </FlexBox>

      <span className={classes.commonText}>
        The email address associated with your account has been updated.
        <br />
        <br />
        You can safely close this page.
      </span>
    </SuccessWrapper>
  );
}
